export default __webpack_public_path__ + "static/media/default_course.331615f5.png";